import { lazy } from "react"
import Home from "../pages/Home";
import Assistant from "../pages/Assistant";
import Calculator from "../pages/Calculator";


const AssistantWiter = lazy(()=>import('../pages/Assistant/Witer'))
const routes = [
  {
    path:'/',
    element:<Home/>
  },
  {
    path:'/home',
    element:<Home/>
  },
  {
    path:'/assistant',
    element:<Assistant/>,
    children:[
      {
        path:'witer', // /assistant/witer
        element:<AssistantWiter/>
      }
    ]
  },
  {
    path:'/calculator',
    element:<Calculator/>
  }

]

export default routes